module.exports = __webpack_public_path__ + "img/avatar.535fb023.jpg";